import dkAxios from '@/jslib/dk-axios'

export const getLogisticsList = data => dkAxios({
  url: '/cms/Logistics',
  method: 'GET',
  params: data,
});

export const getLogisticsDetail = data => dkAxios({
  url: `/cms/Logistics/${data}`,
  method: 'GET',
});

export const getLogisticsOrderDetail = data => dkAxios({
  url: '/cms/Logistics/order',
  method: 'POST',
  data,
});

export const getLogisticsPointOrderDetail = data => dkAxios({
  url: '/cms/Logistics/pointOrder',
  method: 'POST',
  data,
});


export const addLogistics = data => dkAxios({
  url: '/cms/Logistics',
  method: 'POST',
  data,
});

export const updateLogistics = data => dkAxios({
  url: `/cms/Logistics/${data.uuid}`,
  method: 'PUT',
  data,
});

export const editLogistics = data => dkAxios({
  url: `/cms/LogisticsDetail/${data.uuid}`,
  method: 'PUT',
  data,
});


export const deleteLogistics = uuid => dkAxios({
  url: `/cms/LogisticsDetail/${uuid}`,
  method: 'DELETE',
});



// WEBPACK FOOTER //
// ./src/api/logistics.js